module.exports = __webpack_public_path__ + "img/audioUnMute.310baed6.svg";